import { ref } from 'vue'
import { auth } from '@/firebase/config'
import { signInWithEmailAndPassword, signOut, User } from 'firebase/auth'

export function useAuth() {
	const user = ref<User | null>(null)
	const error = ref<string | null>(null)
	const loading = ref(false)

	// Login
	const login = async (email: string, password: string) => {
		error.value = null
		try {
			const userCredential = await signInWithEmailAndPassword(auth, email, password)
			user.value = userCredential.user
			return {
				email: userCredential.user.email,
				uid: userCredential.user.uid
			}
		} catch (err) {
			error.value = (err as Error).message
			throw err
		}
	}

	// Logout
	const logout = async () => {
		error.value = null
		try {
			await signOut(auth)
			user.value = null
		} catch (err) {
			error.value = (err as Error).message
			throw err
		}
	}

	return {
		user,
		error,
		loading,
		login,
		logout
	}
}
